import { Observer } from 'mobx-react';
import { Assistant } from 'modules/Distances/types';
import { getAssistantLabel } from 'modules/Distances/utils/getAssistantLabel';
import React from 'react';

import { AutocompleteWithTags } from 'components/Fields';

import { t } from 'utils';

type Props = {
  value: Array<MedicalAssistantType>;
  options: Array<MedicalAssistantType>;
  selectionUpdate: Array<MedicalAssistantType>;
  onChange: Function;
} & HOC.withIntl;

let Header = ({ onChange, options, value, selectionUpdate }: Props) => {
  const defProps = {
    name: 'medical_assistants',
    placeholder: t.staticAsString('distances.steps.medicalAssistantsForm.placeholder'),
    label: '',
    errors: [],
    disabled: false,
    onClose: (values) => {
      onChange(values);
    },
    getOptionLabel: getAssistantLabel,
  };

  return (
    <Observer>
      {() => {
        return (
          <AutocompleteWithTags
            {...defProps}
            options={options}
            value={value}
            noOptionsText={t.staticAsString('autocomplete.noOptions') as any}
          />
        );
      }}
    </Observer>
  );
};

export { Header };
